define('package-data',['require','exports','module','jquery'],function (require, exports) {
    var $ = require('jquery');

    exports.retrieveConfig = function () {
        var retrievingConfig = $.Deferred();

        var gettingPackageData = $.ajax({
            url: '/public/properties/package.json',
            dataType: 'json'
        });

        gettingPackageData
            .then(function (data) {
                retrievingConfig.resolve(data);
            })
            .fail(function () {
                retrievingConfig.resolve({version: ''});
            });

        return retrievingConfig.promise();
    };
});

